import { createSlice } from '@reduxjs/toolkit';
import axios from '../../utils/axios';
import { dispatch } from '../store';

const initialState = {
    isLoading: false,
    error: null,
    dashboard: [],
};


const slice = createSlice({
    name: 'dashboard',
    initialState,
    reducers: {
        // START LOADING
        startLoading(state) {
            state.isLoading = true;
        },

        // HAS ERROR
        hasError(state, action) {
            state.isLoading = false;
            state.error = action.payload;
        },

        // GET elementS
        getDashboard(state, action) {
            state.isLoading = false;
            state.dashboard = action.payload;
        },

    },
});
export default slice.reducer;


export function getdashboard(name) {
    return async () => {
        dispatch(slice.actions.startLoading());
        try {
            const response = await axios.get(`/api/${name}/dashboard`);
            dispatch(slice.actions.getDashboard(response?.data?.data));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

